 import React from 'react';
import Select from 'react-select';
import "./Selectput.css";

class Selectput extends React.Component {


  handleChange = value => {
    // call setFieldValue and manually update values
    // {value} here is an object with properties {label, value}, so:
    this.setState({
      value: value
    });
    this.props.form.setFieldValue(this.props.field.name, value.value);
    // after a value has been given, the wizard should automatically
    // switch to the next page. However, calling handleSubmit on the parent form
    // did only have an effect after the second change event in the component.
    // Here is a workaround ("The magic is to let it run on the next cycle tick."):
    // @see https://github.com/jaredpalmer/formik/issues/1218#issuecomment-481707848
    setTimeout(this.props.form.handleSubmit, 0);
  };

  handleBlur = () => {
    // call setFieldTouched and manually update touched.topcis
    this.props.form.setFieldTouched(this.props.field.name, true);
    console.log('selectput blur');
  };

  render() {
    let customStyles = {
      option: (provided, state) => ({
        ...provided,
        fontFamily: 'Noto Sans',
        color: state.isSelected ? 'white' : 'black',
        backgroundColor: state.isSelected ? 'grey' : 'white',
        fontSize: "18px",
        letterSpacing: "0.85px",
        lineHeight: "25px",

      }),
      control: (provided) => ({
        ...provided,
        width: "inherit",
        height: "64px",
        margin: "auto",
        borderRadius: "0",
        border: "2px solid #333333",
      }),
      placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Playfair Display',
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
      }),
      indicatorContainer: (provided) => ({
        ...provided,
        width: "50px",
      }),
      container: (provided) => ({
        ...provided,
        width: "570px",
        margin: "auto",

      }),
      menu: (provided) => ({
        ...provided,
        width: "inherit",
        border: "2px solid #333333",
        borderTop: "none",
        marginTop: "0",
        borderRadius: "0",
        boxShadow: " 0px 0px 1px 0 rgba(51, 51, 51, 1)",
        backgroundColor: "rgba(255,255,255,.9)",
      }),
      menuList: (provided) => ({
        ...provided,
        height: "inherit",
        maxHeight: "",
        margin: "0"
      }),
      // https://stackoverflow.com/questions/55452283/react-select-how-to-rotate-dropdown-indicator-when-menu-open
      dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && "scaleY(-1)",
      }),
    }
    return (
      <div className="selectput-widget">
        <label htmlFor={this.props.field.name}>{this.props.label}</label>
        <Select
          id={this.props.field.name}
          options={this.props.options}
          multi={this.props.multi}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          styles={customStyles}
          placeholder={this.props.placeholder}
          // menuIsOpen={true}
          // components={{ DropdownIndicator }}
        />
        {!!this.props.error &&
          this.props.touched && (
            <div style={{ color:  'red', marginTop: '.5rem' }}>{this.props.error}</div>
          )}
      </div>
    );
  }
}

export default Selectput;